import { z } from 'zod';

const ACCOUNT_CONTENT_INPUT = [
  'billing',
  'usage',
  'keys',
  'labs',
  'privacy',
  'channels',
  'cloudAgents',
  'members',
  'profile',
  'security',
  'preferences',
  'sso',
  'git',
  'gitConnections',
] as const;

export type AccountSearchParams = Exclude<(typeof ACCOUNT_CONTENT_INPUT)[number], 'privacy'>;

/** Legacy Privacy tab (`?content=privacy`) now lives under Security & Privacy. */
export function resolveAccountContent(content: (typeof ACCOUNT_CONTENT_INPUT)[number]): AccountSearchParams {
  return content === 'privacy' ? 'security' : content;
}

export const accountContentSchema = z
  .enum(ACCOUNT_CONTENT_INPUT)
  .catch('billing')
  .transform(resolveAccountContent);
